import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import { ReactSVG } from "react-svg";

import classes from "./card1.module.css";
import {
  boldAndItalicStyles,
  calculateStarHeight,
  cardDimentionsAtScaleX,
} from "../../handlers/helperFunctions";

const Card1 = ({
  title,
  mainBg,
  subTitle,
  description,
  createdBy,
  frame,
  border,
  horizontalStrip,
  verticalStrip,
  star,
  bottomStripText,
  cardBacksideImg,
  isFrontView,
  imageRef,
  backImageRef,
  generatingPreview,
}) => {
  const [actualStarCount, setActualStarCount] = useState(["", "", "", "", ""]);
  useEffect(() => {
    let _c = [];
    for (let i = 0; i < star?.count; i++) {
      _c.push("");
    }
    setActualStarCount(_c);
  }, [star?.count]);

  return (
    <div>
      {/* {isFrontView && ( */}
      <div
        ref={imageRef}
        style={{
          ...cardDimentionsAtScaleX(2),
          height: generatingPreview ? "1080px" : "calc(100vh - 76px)",
        }}
        className={`${classes?.dflex} ${
          !isFrontView && !generatingPreview && classes?.hideContainer
        }`}
      >
        <div
          className={classes?.container}
          style={{
            scale: generatingPreview ? "4" : "2",
          }}
        >
          {frame?.isVisible && (
            <img
              src={frame?.url}
              className={classes?.frameImg}
              draggable={false}
            />
          )}
          {mainBg?.type?.split("/")[1] == "svg+xml" ||
          (!mainBg?.type && mainBg?.split(".")[2] == "svg") ? (
            <ReactSVG
              src={typeof mainBg == "string" ? mainBg : mainBg}
              className={classes?.mainBgImg}
              draggable={false}
            />
          ) : (
            <img src={mainBg} className={classes?.mainBgImg} />
          )}

          {border?.isVisible && (
            <img
              src={border?.url}
              className={classes?.borderImg}
              draggable={false}
            />
          )}

          {/* horizontal strip */}
          {horizontalStrip?.isVisible && (
            <img
              src={horizontalStrip?.url}
              className={classes?.horizontalStripImg}
              draggable={false}
            />
          )}
          {star?.isVisible && (
            <div className={classes?.horizontalStripStarContainer}>
              {actualStarCount.fill(star?.url)?.map((st, i) => {
                return (
                  <img
                    src={st}
                    key={i}
                    className={classes?.starImg}
                    style={{ width: calculateStarHeight(star?.count) }}
                  />
                );
              })}
            </div>
          )}

          {/* Verticle Strop */}
          {verticalStrip?.isVisible && (
            <img
              src={verticalStrip?.url}
              className={classes?.verticalStripImg}
              draggable={false}
            />
          )}
          {star?.isVisible && (
            <div className={classes?.verticleStripStarContainer}>
              <p
                className={`${classes?.createdByText} maxLine1 m-0`}
                style={{
                  color: bottomStripText?.color,
                  ...boldAndItalicStyles(
                    bottomStripText?.fontStyle,
                    bottomStripText?.fontWeight
                  ),
                }}
              >
                {bottomStripText?.text}
              </p>
              {/* {actualStarCount.fill(star?.url)?.map((st, i) => {
                return (
                  <img
                    src={st}
                    key={i}
                    className={classes?.starImg}
                    style={{ width: calculateStarHeight(star?.count) }}
                  />
                );
              })} */}
            </div>
          )}

          {/* Draggable Container */}
          <div className={classes?.draggableContainer}>
            {/* Title */}
            {title?.isVisible && (
              <Draggable bounds="parent" defaultPosition={{ y: 140, x: 10 }}>
                <div className={classes?.titleContainer}>
                  <img
                    src={title?.url}
                    className={classes?.textBg}
                    draggable={false}
                  />
                  <h1
                    className={`${classes?.titleText} maxLine1`}
                    style={{
                      color: title?.color,
                      ...boldAndItalicStyles(
                        title?.fontStyle,
                        title?.fontWeight
                      ),
                    }}
                  >
                    {title?.text}
                  </h1>
                </div>
              </Draggable>
            )}
            {/* Sub Title */}
            {subTitle?.isVisible && (
              <Draggable bounds="parent" defaultPosition={{ y: 140, x: 15 }}>
                <div className={classes?.subTitleContainer}>
                  <img
                    src={subTitle?.url}
                    className={classes?.subTitletextBg}
                    draggable={false}
                  />
                  <p
                    className={`${classes?.subTitleText} maxLine1`}
                    style={{
                      color: subTitle?.color,
                      ...boldAndItalicStyles(
                        subTitle?.fontStyle,
                        subTitle?.fontWeight
                      ),
                    }}
                  >
                    {subTitle?.text}
                  </p>
                </div>
              </Draggable>
            )}
            {/* Description */}
            {description?.isVisible && (
              <Draggable bounds="parent" defaultPosition={{ y: 143, x: 0 }}>
                <div
                  style={{
                    // boxShadow: "0 4px 30px rgba(255,255,255,0.2)",
                    background: `rgba(255,255,255,${description?.transparency})`,
                    backdropFilter: `blur(${description?.blur}px)`,
                    border: `1px solid rgba(255,255,255, ${description?.outline})`,
                  }}
                >
                  <Draggable bounds="parent" defaultPosition={{ y: 0, x: 22 }}>
                    <div className={classes?.descriptionContainer}>
                      <p
                        className={`${classes?.descriptionText} maxLine4`}
                        style={{
                          color: description?.color,
                          ...boldAndItalicStyles(
                            description?.fontStyle,
                            description?.fontWeight
                          ),
                        }}
                      >
                        {description?.text}
                      </p>
                    </div>
                  </Draggable>
                </div>
              </Draggable>
            )}

            {/* createdBy */}
            {createdBy?.isVisible && (
              <Draggable bounds="parent" defaultPosition={{ y: 147, x: 50 }}>
                <div className={classes?.createdByContainer}>
                  <p
                    className={`${classes?.createdByText} maxLine1`}
                    style={{
                      color: createdBy?.color,
                      ...boldAndItalicStyles(
                        createdBy?.fontStyle,
                        createdBy?.fontWeight
                      ),
                    }}
                  >
                    Created By: {createdBy?.text}
                  </p>
                </div>
              </Draggable>
            )}
          </div>
        </div>
      </div>
      {/* )} */}
      {/* Card BackSide */}
      {/* {!isFrontView && ( */}
      <div
        ref={backImageRef}
        style={{
          ...cardDimentionsAtScaleX(2),
          height: generatingPreview ? "1080px" : "calc(100vh - 76px)",
        }}
        // className={[classes?.dflex, isFrontView && classes?.hideContainer].join(
        //   " "
        // )}

        className={`${classes?.dflex} ${
          isFrontView && !generatingPreview && classes?.hideContainer
        }`}
      >
        <div
          className={`${classes?.container}`}
          style={{
            scale: generatingPreview ? "4" : "2",
          }}
        >
          {cardBacksideImg?.type?.split("/")[1] == "svg+xml" ||
          (!cardBacksideImg?.type &&
            cardBacksideImg?.split(".")[2] == "svg") ? (
            <ReactSVG
              src={
                typeof cardBacksideImg == "string"
                  ? cardBacksideImg
                  : cardBacksideImg
              }
              className={classes?.mainBgImg}
              draggable={false}
            />
          ) : (
            <img src={cardBacksideImg} className={classes?.mainBgImg} />
          )}
        </div>
      </div>
      {/* )} */}
    </div>
  );
};

export default Card1;
